export const CAURL = {
    CA_DASHBOARD: '/ca/dashboard',
    CA_ALL_CLIENTS: '/ca/clients',
    CA_ALL_CLIENTS_INVOICES: '/ca/invoices',
    CA_SETTINGS: '/ca/settings',
    CA_NOTIFICATIONS_MANAGEMENT: '/ca/notifications',

    CA_CLIENTS_INVOICE_EDIT: '/ca/invoices/:invoiceId/edit',
    ca_clients_invoice_edit: (invoiceId) => `/ca/invoices/${invoiceId}/edit`,

    // teams urls
    CA_TEAMS_DASHBOARD: '/ca/teams/teams',
    CA_ALL_TEAMS: '/ca/teams/detailed-view',
    CA_TEAMS_TASKS: '/ca/teams/tasks',
    CA_TEAMS_CALENDAR: '/ca/teams/calendar',
    CA_TEAMS_ACTIVITY: '/ca/teams/activity',
    CA_TEAMS_EMPLOYEES: '/ca/teams/employees',
    CA_TEAMS_EMPLOYEES_VIEW: '/ca/teams/employees/:employeeId',
    ca_teams_employees_view: (employeeId) => `/ca/teams/employees/${employeeId}`,

    // firm related urls
    CA_FIRM_OVERVIEW: '/ca/firm/home',
    CA_FIRM_DEPARTMENTS: '/ca/firm/department',
    CA_FIRM_OFFICES: '/ca/firm/offices',
    CA_FIRM_ROLES: '/ca/firm/roles',
    CA_FIRM_MEMBERS: '/ca/firm/members',
    CA_FIRM_SETTINGS: '/ca/firm/settings',

    // finance related urls
    CA_FINANCE_DASHBOARD: '/ca/finance/dashboard',
    CA_FINANCE_BOOKS_LEDGERS: '/ca/finance/books-and-ledgers',
    CA_FINANCE_JOURNAL_ENTRIES: '/ca/finance/journal-entries',
    CA_FINANCE_VOUCHERS: '/ca/finance/vouchers',
    CA_FINANCE_CLIENT_PAYMENTS_PAGE: '/ca/finance/client-payments',
    CA_FINANCE_SHOW_ALL_CLIENT_PAYMENT_REQUESTS_PAGE: '/ca/finance/client-payments/all',
    CA_FINANCE_FIRM_EARNINGS: '/ca/finance/earnings',
    CA_FINANCE_EDIT_CLIENT_PAYMENTS_PAGE: '/ca/finance/client-payments/:paymentRequestId',
    ca_finance_edit_client_payments_page: (paymentRequestId) => `/ca/finance/client-payments/${paymentRequestId}`,
}
